module.exports = __webpack_public_path__ + "assets/img/55mais.e36730f0.png";